// import { utils } from '../../utils';
import s from './index.module.css';

export function ProductWithoutImage({ product, idx }) {
  const price = product.selling_price || 0;
  const discounted = product.discounted_price || 0;
  const discounted_percent = (price - discounted) / price * 100;
  // const image = product.images?.[0] ? utils.getImageUrl(product.images?.[0]) : null;
  const formatPrice = (price) => `₹${price.toFixed(2)}`;

  return (
    <li key={idx} className={s.productItem}>
      <div className={s.productInfo}>
        {product.name && (
          <div className={s.productTitle}>{product.name}</div>
        )}

        {product.short_desc && (
          <div className={s.productDescription}>{product.short_desc}</div>
        )}

        {product.long_desc && (
          <div className={s.productDescription}>{product.long_desc}</div>
        )}

        {(discounted > 0 || price > 0) && (
          <div className={s.productPricing}>
            {discounted > 0 && (
              <span className={s.productDiscounted}>{formatPrice(discounted)}</span>
            )}
            {price > 0 && (
              <span className={s.productOriginal}>{formatPrice(price)}</span>
            )}
            {discounted > 0 && price > 0 && (
              <span className={s.productDiscount}>
                {Math.round(discounted_percent)}% off
              </span>
            )}
          </div>
        )}
      </div>
    </li>
  );

}